import { render } from "./EndScreenLossView.vue?vue&type=template&id=1b44943d&scoped=true"
import script from "./EndScreenLossView.vue?vue&type=script&lang=js"
export * from "./EndScreenLossView.vue?vue&type=script&lang=js"

import "./EndScreenLossView.vue?vue&type=style&index=0&id=1b44943d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b44943d"]])

export default __exports__